import React, { Component } from 'react'
// import logo from '../../assets/images/logo.png'
import Swal from 'sweetalert2'
import moment from 'moment'
import { numbertoWord } from '../../utils'
export default class LoiPreview extends Component {
    constructor(props) {
        super()
        this.state = {

        }
    }
    onSend = () => {
        debugger
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to Send Offer",
            // icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send it !'
        }).then(res => {
            if (res.isConfirmed) {
                this.props.onSend()

                // Swal.fire({
                //     // title: 'Auto close alert!',
                //     html: 'Sending....',
                //     timer: 2000,
                //     // timerProgressBar: true,
                //     didOpen: () => {
                //         Swal.showLoading()
                //         // const b = Swal.getHtmlContainer().querySelector('b')
                //         // let timerInterval = setInterval(() => {
                //         // }, 100)
                //     },
                //     willClose: () => {
                //         clearInterval()
                //     }
                // })

            }
        })
    }


    render() {
        console.log("model", this.props.model);
        const { model } = this.props
        return (
            <React.Fragment>
                <div className='col-md-9'>
                    <div style={{ textAlign: 'right', marginTop: '10px' }}>
                        <button className="btn btn-primary" style={{ margin: "10px" }} onClick={() => this.props.onEdit()}>
                            Edit
                        </button>
                        <button className="btn btn-primary"
                            onClick={() => this.onSend()}
                        >
                            Send
                        </button>

                    </div>

                    <div className='' style={{ border: "2px solid #ddd", padding: '20px', borderRadius: '4px' }}>
                        <table style={{ width: '100%', marginTop: "10px" }}>

                            {/* <tbody>

                                        <tr>
                                            <td colSpan={2}>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td  colSpan={2} style={{textAlign: "center"}}>
                                                <img src={'logo.png'} style={{ width: '150px', textAlign: 'center' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td  colSpan={2} style={{height:'2px'}}></td>
                                        </tr>
                                        <tr>
                                            <td  colSpan={2} style={{ textAlign: 'center' }}>
                                                <h4>Letter of Intent</h4>
                                            </td>
                                        </tr>
                                    </tbody> */}
                            <tbody>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} align="center" style={{ textAlign: "right" }} >
                                        <img src={process.env.REACT_APP_BASE_URL + `/company/logo/${model.CompanyLogo}`} style={{ width: "100px", textAlign: "center" }} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "4px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ align: "center", textAlign: "left" }} >
                                        <h4>Letter of Intent</h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "20px" }} height="20px"></td>
                                </tr>
                                <tr>
                                    <td width="397">Dear <strong>{model.CandidateName}</strong></td>
                                    <td width="397" style={{ textAlign: "right", align: "right" }} ><strong>Date: </strong>
                                        {/* {model?.CREATED_ON} */}
                                        {moment(model.CREATED_ON).format('Do MMM YYYY')}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>Thank you for the keen interest you have shown in our organization. Consequent to your application and the subsequent discussions you had with us, we are pleased  to offer you a career with us at CTC of Rs<strong>.{model.ctc} LPA.</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>We welcome your decision to join our organization as <strong>{model.Designation} </strong>We are sure that together we will preserve the Core Values  that we stand for and work towards  a mutually beneficial relationship.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>You are requested to contact to take  on your assignment on or before <strong>{moment(model.DateOfJoining).format('Do MMM YYYY')}</strong> at the following address:</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><strong>{model.CompanyName}<br />
                                        {model.Address}<br />
                                        {model.City}{model.State}{model.Country}{model.PinCode}
                                    </strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>A formal letter of appointment including the service terms  and conditions will be issued to you on your joining. However, it is clarified  that initially you shall be on probation of six months, which shall be extendable, and you shall not be deemed to be confirmed till you are confirmed in writing. The contract  will be terminable by giving <strong>{model.NoticePeriod} notice </strong>or without any notice upon performance / fitment / attitude  issues or any breach of terms.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>If your services  are found satisfactory during the probation period, you will be confirmed in the present position. After confirmation your services may be terminated by giving notice  in writing for Two month or payment of Two month&rsquo;s salary in  lieu thereof.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>In case you need any further clarification / assistance,  please get in touch with the undersigned.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>You are supposed to bring &amp; submit the copy for the list  of documents as mentioned in Annexure 1, enclosed with this offer letter.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>You are being offered on the presumption that the  particulars furnished by you in your Application and/or Resume are correct. In  case the said particulars are found to be incorrect or that you have concealed  or withheld some other relevant facts, your offer with the company shall stand  Terminated/Cancelled without any notice.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ lineHeight: "22px" }}>Please sign and return to us the duplicate copy of this  letter as a token of your acceptance. I hope that your tenure with us would  bring about prosperity and mutually fruitful relationships. This offer is  subject to your joining us on or before <strong>{moment(model.DateOfJoining).format('Do MMM YYYY')}.</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>Looking forward to you joining the MTC team.</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td style={{ width: "397px" }}>Best wishes,<br />
                                        <strong>For</strong><br />
                                        <strong>{model.CompanyName}</strong></td>
                                    <td style={{ width: "397px" }}>I accept this offer<br /><br />
                                        <hr style={{ borderTop: "2px dotted #444444" }} /><br />
                                        Signature of the candidate</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><strong>Encl.:</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "8px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><strong>1. </strong>List of Documents to be submitted <strong>(Annexure1)</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ textAlign: "center" }} ><strong>Annexure  1</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><p style={{ align: "center" }}><strong><u>List of Documents to be submitted at  the time of Joining</u></strong><strong> </strong></p></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>On the date of joining, it is  mandatory for you to submit the photocopies of the following documents (Please  do bring the original testimonials for verification purpose):-</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ height: "0px" }} ></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <ol style={{ marginLeft: '20px' }}>
                                            <li>Relieving  Letter/Certificate from the previous Employer.</li>
                                            <li>Proof  of last salary drawn salary (copy of salary certificate/salary slip).</li>
                                            <li>Experience  Certificate from the previous employer.</li>
                                            <li>Educational  Certificates &amp; mark sheets (Class 10th/12th/equivalent onwards)</li>
                                            <li>Copy  of Driving License/Passport/Photo I.D Proof.</li>
                                            <li>Passport  Size photographs (4 in nos.)</li>
                                            <li>Cancelled Cheque</li>
                                            <li>Vaccination Certificate</li>
                                        </ol></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                {(model.MedicalInsurance || model.AccidentalInsurance) && <tr>
                                    <td colSpan={2}>Medical Benefits:</td>
                                </tr>}
                                <tr>
                                    <td colSpan={2} style={{ height: "0px" }}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <ol style={{ marginLeft: '20px' }}>
                                            {model.MedicalInsurance && <li>Mediclaim  – {model.MedicalInsurance}</li>}
                                            {model.AccidentalInsurance && <li>Accidental  insurance – {model.AccidentalInsurance}</li>}
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <button className="btn btn-primary" style={{ margin: "10px" }} onClick={() => this.props.onEdit()}>
                            Edit
                        </button>
                        <button className="btn btn-primary"
                            onClick={() => this.onSend()}
                        >
                            Send
                        </button>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}
